import styled from 'styled-components';
import { mq, mediumBreakpoint, Icon, Shape, Paragraph } from '@phishtool/ui';
export const StyledContentWrapper = styled.div.withConfig({ displayName: "StyledContentWrapper", componentId: "-14s6j7" }) `
  flex: 1;
  transition: transform 0.2s;
`;
export const StyledWrapper = styled.a.withConfig({ displayName: "StyledWrapper", componentId: "-d8uzrq" }) `
  background-color: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => props.theme.borderRadius.primary};
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  text-decoration: none;
  color: ${(props) => props.theme.body.textColor};
  position: relative;
  transition: background 0.2s;

  ${(props) => mq({
    padding: [
        `${props.theme.spacers.xxl} ${props.theme.spacers.large}`,
        null,
        `${props.theme.spacers.massive} ${props.theme.spacers.xxl}`,
    ],
})}

  @media (min-width: ${mediumBreakpoint}px) {
    &:hover {
      border-color: ${(props) => props.theme.colors.littleBoyBlue};
      background-color: ${(props) => props.theme.colors.celticBlue};

      * {
        color: ${(props) => props.theme.colors.white};
      }

      .icon {
        opacity: 0;
      }

      .shape::before {
        border-color: ${(props) => props.theme.colors.white};
      }

      ${StyledContentWrapper} {
        transform: translateY(-60px);
      }
    }
  }
`;
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon", componentId: "-3f1ix5" }) `
  transition: opacity 0.2s;

  ${(props) => mq({
    marginBottom: [props.theme.spacers.large, null, props.theme.spacers.xxl],
})}
`;
export const StyledShape = styled(Shape).withConfig({ displayName: "StyledShape", componentId: "-1vy39r4" }) `
  bottom: 55px;
  transform: rotate(45deg);

  &::before {
    width: 24px;
    height: 24px;
    border-width: 8px 8px 0 0;
    transition: border-color 0.2s;
  }

  ${mq({
    position: ['static', null, 'absolute'],
})}
`;
export const StyledParagraph = styled(Paragraph).withConfig({ displayName: "StyledParagraph", componentId: "-1oh2g9b" }) `
  ${(props) => mq({
    color: [props.theme.body.textColor, null, props.theme.colors.white],
    lineHeight: ['unset', null, '28px'],
})}
`;
